import {useEffect, useRef} from 'react';
import {useAppDispatch} from '@/hooks';
import {addOrderStateNew, addToCurrentProcessingIds, DownloadStateTypes} from '@Components/download-panel/download-panel.reducer';
import {getOngoingDownloads, type OngoingOrderDetail} from '@Libraries/poster-download-library';
import {FileTypeOptions} from '@Components/download-panel/components/file-type-option/file-type-option.types';
import {isUserLoggedIn, isUserPremium} from '@Libraries/user.library';

export const useRestoreOngoingDownloads = (idPoster: string | undefined = undefined, hasPageLoaded = true): void => {
  const dispatch = useAppDispatch();
  const hasRestoredRef = useRef(false);

  useEffect(() => {
    if (hasRestoredRef.current || !hasPageLoaded) {
      return;
    }

    const restoreOngoingDownloads = async (): Promise<void> => {
      try {
        const response = await getOngoingDownloads(idPoster);

        if (response.orders && Array.isArray(response.orders) && response.orders.length > 0) {
          response.orders.forEach((order: OngoingOrderDetail) => {
            dispatch(addToCurrentProcessingIds(order.idOrderKey));

            dispatch(
              addOrderStateNew({
                orderId: order.idOrder,
                orderIdKey: order.idOrderKey,
                state: DownloadStateTypes.DOWNLOADING,
                isPaygDownload: !isUserPremium(),
                name: order.name,
                fileType: (order.fileType as FileTypeOptions) || FileTypeOptions.JPG,
                displayProgress: 0,
                thumbnailUrl: order?.thumbnailUrl,
              })
            );
          });
        }

        hasRestoredRef.current = true;
      } catch (error) {
        console.error('Failed to restore ongoing downloads:', error);
        hasRestoredRef.current = true;
      }
    };

    if (isUserLoggedIn()) {
      void restoreOngoingDownloads();
    }
  }, [hasPageLoaded]);
};
